import React from "react";
import BannerCms from "../components/BannerCms";
import AppDownloadSection from "../components/AppDownloadSection";

const Teams = () => {
  return (
    <>
      <BannerCms
        title="Current as of 20 Jan 2022"
        subtitle="Terms and conditions"
        description="By accessing our website, you are agreeing to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws."
      />
      <section className="policy-content">
        <div className="container">
          <p>
            Welcome to Pegiora Inc. ("Company," "we," "us," or
            "our"). These Terms and Conditions ("Terms") govern your access to
            and use of our mobile application and website ("Platform"), as well
            as the courier delivery services ("Services") offered through the
            Platform. By accessing or using the Platform, you agree to comply
            with and be bound by these Terms.
          </p>
          <h3>Definitions</h3>

          <p>
            <b>User:</b> Any individual or entity that accesses or uses the
            Platform.
            <br />
            <b>Driver:</b> An individual or entity who performs delivery
            services through the Platform. <br />
            <b>Sender:</b> An individual or entity who initiates a delivery
            request via the Platform.
            <br />
            <b>Recipient:</b> The individual or entity designated to receive the
            delivered items. <br />
            <b>Service:</b> The courier delivery services offered through the
            Platform, specifically focusing on medical supplies and e-commerce
            products. <br />
            <b>Platform:</b> The mobile application and website operated by Pegiora Inc.
          </p>

          <h3>Acceptance of Terms</h3>

          <p>
            By accessing or using the Platform, you hereby acknowledge that you
            have read, understood, and agree to be bound by these Terms. If you
            do not agree with these Terms, you must immediately cease use of the
            Platform and any Services offered therein.
          </p>
          <h3>Modification of Terms</h3>
          <p>
            Pegiora Inc. reserves the right to modify, amend, or
            update these Terms at any time and for any reason. Changes will be
            effective immediately upon posting on the Platform. Your continued
            use of the Platform and Services after such modifications will
            constitute your acknowledgment of the modified Terms and your
            agreement to abide and be bound by them.
          </p>
          <h3>Eligibility and Account Creation</h3>
          <p>
            To use the Services, you must be at least 18 years of age and
            capable of forming a binding contract. You may be required to create
            an account ("Account") and provide certain personal information. You
            agree to provide accurate, current, and complete information during
            the registration process and to update such information to keep it
            accurate, current, and complete.
          </p>

          <h3>User Responsibilities</h3>
          <p>
            <b>By using the Platform, you represent and warrant that:</b>
            <br />
            You have the legal capacity to enter into these Terms and to fulfill
            your obligations herein.
            <br /> You will comply with all applicable local, state, and federal
            laws and regulations concerning your use of the Platform and
            Services.
            <br /> You will not use the Platform for any unlawful or prohibited
            purpose.
            <br /> You will maintain the confidentiality of your Account
            information.
          </p>
          <h3>Service Description</h3>
          <p>
            Pegiora Inc. offers a courier delivery service through
            its Platform. The Service is designed to facilitate the delivery of
            medical supplies and e-commerce products. It does not include food
            delivery. For details on shipping and refunds, please refer to our
            separate Shipping and Refund Policy.
          </p>
          <h3>Pricing and Payment</h3>
          <p>
            The pricing for the Services will be as stated on the Platform at
            the time of your request. All payments are to be made through the
            payment methods available on the Platform. By using the Services,
            you agree to abide by the pricing and payment terms as we may update
            them from time to time.
          </p>

          <h3>Delivery Process</h3>
          <p>
            Upon confirmation of your delivery request, a Driver will be
            assigned to fulfill the delivery. You will be provided with
            real-time tracking and status updates through the Platform. Pegiora Inc.
             is not responsible for any delays caused by
            factors beyond our control, including but not limited to traffic,
            weather, or mechanical failures.
          </p>

          <h3>Driver Requirements</h3>
          <p>
            All Drivers are subject to a thorough background check and must meet
            the qualifications set forth by Pegiora Inc. Drivers
            are independent contractors and are not employees of 
            Pegiora Inc. They are solely responsible for the delivery services
            they provide.
          </p>

          <h3>User Conduct</h3>
          <p>
            Users are expected to conduct themselves in a lawful and respectful
            manner when using the Platform and Services. Any behavior deemed
            harmful, harassing, or in violation of these Terms may result in
            immediate termination of your Account and access to the Platform.
          </p>
          <h3>Data Privacy</h3>
          <p>
            Your privacy is important to us. All personal information collected
            through the Platform is handled in accordance with our Privacy
            Policy, which is hereby incorporated by reference into these Terms.
          </p>
          <h3>Confidentiality</h3>
          <p>
            Users may have access to confidential information ("Confidential
            Information") while using the Platform. You agree to maintain the
            confidentiality of such information and not to disclose or use it
            for any purpose other than as necessary to use the Services.
          </p>
          <h3>Dispute Resolution</h3>
          <p>
            Any disputes arising out of or relating to these Terms, the
            Platform, or the Services will be resolved through binding
            arbitration, rather than in court, except for matters that can be
            taken to small claims court. The arbitration will be conducted in
            the State of Ohio, USA, and judgment on the arbitration award may be
            entered into any court having jurisdiction thereof.
          </p>
          <h3>Limitation of Liability</h3>
          <p>
            To the fullest extent permitted by applicable law, 
            Pegiora Inc. shall not be liable for any indirect, incidental,
            special, consequential, or punitive damages, or any loss of profits
            or revenues, whether incurred directly or indirectly, or any loss of
            data, use, goodwill, or other intangible losses, resulting from your
            use or inability to use the Platform or Services.
          </p>
          <h3>Indemnification</h3>
          <p>
            You agree to indemnify, defend, and hold harmless 
            Pegiora Inc., its officers, directors, employees, agents, and
            third parties, for any losses, costs, liabilities, and expenses
            (including reasonable attorneys' fees) relating to or arising out of
            your use of or inability to use the Platform or Services, your
            violation of any terms of this Agreement or your violation of any
            rights of a third party, or your violation of any applicable laws,
            rules, or regulations.
          </p>
          <h3>Intellectual Property</h3>
          <p>
            All content, trademarks, services marks, trade names, logos, and
            icons are the property of Pegiora Inc. or its
            affiliates or agents and are protected by copyright laws and
            international treaties and provisions. You agree not to delete the
            copyright or other proprietary rights notice from any content.
          </p>
          <h3>Third-Party Services</h3>
          <p>
            The Platform may contain links to third-party websites or services
            that are not owned or controlled by Pegiora Inc. We
            have no control over, and assume no responsibility for, the content,
            privacy policies, or practices of any third-party websites or
            services.
          </p>
          <h3>Termination of Account</h3>
          <p>
            Pegiora Inc. reserves the right to terminate or
            suspend your Account and access to the Platform and Services for
            conduct that we believe violates these Terms or is harmful to other
            users of the Platform, us, or third parties, or for any other
            reason.
          </p>
          <h3>Governing Law</h3>
          <p>
            These Terms shall be governed by and construed in accordance with
            the laws of the State of Ohio, USA, without regard to its conflict
            of law principles.
          </p>
          <h3>Non-Discrimination Policy</h3>
          <p>
            Pegiora Inc. is committed to providing an inclusive
            and welcoming environment for all users of the Platform and
            Services. We do not discriminate on the basis of race, color,
            religion, gender, gender expression, age, national origin,
            disability, marital status, sexual orientation, or military status.
          </p>
          <h3>Safety Measures</h3>
          <p>
            Pegiora Inc. prioritizes the safety of all Users and
            Drivers. We implement various safety protocols and measures, but we
            cannot guarantee absolute safety. You agree to use the Platform and
            Services at your own risk.
          </p>
          <h3>Feedback and Reviews</h3>
          <p>
            Users are encouraged to provide feedback and reviews about the
            Services. By submitting feedback, you grant Pegiora
            Inc. the right to use, publish, and modify your feedback for any
            purpose without any obligation to compensate you.
          </p>
          <h3>Severability</h3>
          <p>
            If any provision of these Terms is found to be invalid or
            unenforceable by a court of competent jurisdiction, such provision
            shall be severed from the remainder of these Terms, which will
            otherwise remain in full force and effect.
          </p>
          <h3>Contact Information</h3>
          <p>
            For any questions about these Terms, the Platform, or the Services,
            please contact us at info@pegiora.com.
          </p>
        </div>
      </section>

      <AppDownloadSection />
    </>
  );
};

export default Teams;
